var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { Swipeable } from 'react-swipeable';
import throttle from 'lodash/throttle';
var SimpleCarousel = /** @class */ (function (_super) {
    __extends(SimpleCarousel, _super);
    function SimpleCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.itemRef = React.createRef();
        _this.itemCollectionRef = React.createRef();
        _this.getCurrentItemWidth = function () {
            // return this.getWidth(this.itemRef.current);
            return 100;
        };
        _this.getCurrentTotalItemsWidth = function () {
            return _this.getCurrentItemWidth() * _this.props.items.length;
        };
        _this.goToBtnNav = function (event) {
            var dir = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                dir[_i - 1] = arguments[_i];
            }
            var _a = (_this.props || {}).items, items = _a === void 0 ? [] : _a;
            var itemsLength = (items === null || items === void 0 ? void 0 : items.length) - 1;
            var direction = dir.length
                ? dir[0]
                : event.currentTarget.dataset.direction;
            var itemWidth = _this.getCurrentItemWidth();
            itemWidth = direction === 'prev' ? itemWidth : -itemWidth;
            var _b = _this.showHideNavButtons(direction, itemsLength), prevBtn = _b.prevBtn, nextBtn = _b.nextBtn, index = _b.index;
            _this.setState({
                offsetStart: _this.state.offsetStart + itemWidth,
                activeIndex: index,
                isPrevButton: prevBtn,
                isNextButton: nextBtn,
            });
        };
        _this.updateIndicator = function (direction, itemsLength) {
            var prevIndex = _this.state.activeIndex;
            if (prevIndex >= 0 && prevIndex <= itemsLength) {
                prevIndex += direction === 'prev' ? -1 : +1;
            }
            return prevIndex;
        };
        _this.swipeAnalytic = function () {
            // TODO
            // analytics?.pushMyAccountButtonEvent(this.props.analyticsText);
        };
        _this.handleSwipe = throttle(function (event) {
            if (_this.props.analyticsCall) {
                _this.swipeAnalytic();
            }
            var touchDirection = event.dir === 'Left' ? 'next' : 'prev';
            var itemsLength = _this.props.items.length - 1;
            var index = _this.updateIndicator(touchDirection, itemsLength);
            if (index >= 0 && index <= itemsLength) {
                _this.goToBtnNav(event, touchDirection);
            }
        }, 500, { trailing: false });
        _this.state = {
            offsetStart: 0,
            activeIndex: 0,
            isPrevButton: false,
            isNextButton: true,
        };
        _this.goToBtnNav = _this.goToBtnNav.bind(_this);
        _this.showHideNavButtons = _this.showHideNavButtons.bind(_this);
        _this.goToSlide = _this.goToSlide.bind(_this);
        return _this;
    }
    SimpleCarousel.prototype.showHideNavButtons = function (direction, itemsLength) {
        var rest = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            rest[_i - 2] = arguments[_i];
        }
        var prevBtn = false;
        var nextBtn = false;
        var index = rest[0]
            ? rest[1]
            : this.updateIndicator(direction, itemsLength);
        if (index === 0) {
            prevBtn = false;
            nextBtn = true;
        }
        else if (index === itemsLength) {
            nextBtn = false;
            prevBtn = true;
        }
        else {
            nextBtn = true;
            prevBtn = true;
        }
        return { prevBtn: prevBtn, nextBtn: nextBtn, index: index };
    };
    SimpleCarousel.prototype.goToSlide = function (event) {
        var itemsLength = this.props.items.length - 1;
        var currentIndex = this.state.activeIndex;
        var nextIndex = Number(event.currentTarget.dataset.index);
        if (currentIndex !== nextIndex) {
            var direction = currentIndex < nextIndex ? 'next' : 'prev';
            var itemWidth_1 = this.getCurrentItemWidth() * nextIndex;
            var _a = this.showHideNavButtons(direction, itemsLength, 'isFromIndicator', nextIndex), prevBtn_1 = _a.prevBtn, nextBtn_1 = _a.nextBtn;
            this.setState(function () {
                var newOffsetStart = 0;
                return {
                    offsetStart: newOffsetStart - itemWidth_1,
                    activeIndex: nextIndex,
                    isPrevButton: prevBtn_1,
                    isNextButton: nextBtn_1,
                };
            });
        }
    };
    SimpleCarousel.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var styleAttributes = {
            transform: "translateX(".concat(this.state.offsetStart, "%)"),
            transition: 'all 350ms ease-out',
        };
        return (React.createElement("div", { className: "simple-carousel-container sui-relative sui-w-full sui-overflow-hidden sui-flex sui-flex-col sui-justify-between sui-h-full", "data-testid": "simple-carousel-container" },
            React.createElement(Swipeable, { onSwipedLeft: function (err) { return _this.handleSwipe(err); }, onSwipedRight: function (err) { return _this.handleSwipe(err); } },
                React.createElement("ul", { "data-testid": "carousel-slides-ul", className: "sui-relative sui-w-full sui-flex sui-flex-row sui-flex-nowrap sui-list-none sui-y-4", ref: this.itemCollectionRef, style: styleAttributes }, (_a = this.props.items) === null || _a === void 0 ? void 0 : _a.map(function (item, index) { return (React.createElement("li", { "data-testid": "carousel-slide-li", style: { minWidth: '100%' }, key: index, ref: _this.itemRef }, _this.props.render(item, index))); }))),
            this.props.showIndicators && (React.createElement("ul", { "data-testid": "carousel-indicators-ul", className: "sui-list-none sui-flex sui-flex-row sui-justify-center sui-mb-3" }, (_b = this.props.items) === null || _b === void 0 ? void 0 : _b.map(function (item, index) { return (React.createElement("li", { className: "sui-px-2", key: index, "data-testid": "carousel-indicator-li" },
                React.createElement("button", { type: "button", "data-index": index, "data-item": item, "aria-label": "carousel", className: "sui-rounded-full transition-opacity duration-150 ease-[cubic-bezier(0.4, 0, 1, 1)] cursor-pointer", style: {
                        width: '11px',
                        height: '11px',
                        background: "".concat(index === _this.state.activeIndex ? '#FF9632' : '#D8D8D8'),
                    }, onClick: _this.goToSlide }, "\u00A0"))); })))));
    };
    return SimpleCarousel;
}(React.Component));
export { SimpleCarousel };
